import './Privacy.css';
import { useTranslation } from 'react-i18next';
import { privacyData } from 'data/privacy-data';
import BackToTop from 'components/BackToTop';
import { useEffect } from 'react';

const Privacy = () => {
    const { i18n } = useTranslation();
    const lang = i18n.language?.split("-")[0];

    const sections = privacyData[lang] || privacyData.en;

    // Set page title correctly
    useEffect(() => {
        document.title = "Privacy Policy - Umi Sushi";
    }, []);

    return (
        <main className="privacy">
            <div className="content">
                <BackToTop />
                <h1>{lang === "pt" ? "Política de Privacidade" : "Privacy Policy"}</h1>

                {sections.map((section, idx) => (
                    <section key={idx}>
                        <h2>{section.title}</h2>
                        {Array.isArray(section.content)
                            ? section.content.map((line, i) => <p key={i}>{line}</p>)
                            : <p>{section.content}</p>
                        }
                        {section.list && (
                            <ul>
                                {section.list.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        )}
                        {section.footer && <p>{section.footer}</p>}
                    </section>
                ))}
            </div>
            
        </main>
    );
};

export default Privacy;